module.exports = __webpack_public_path__ + "img/img25.1aaa839.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/img25.png
// module id = 370
// module chunks = 0